import React from 'react'

import Layout from '../components/Layout'
import SEO from '../components/SEO'
import PageHeader from '../components/PageHeader'
import { PageContent } from '../styles/author.styles'

export default function AboutPage() {
  return (
    <Layout>
      <SEO title="Privacy" pathname={`/privacy/`} />
      <PageHeader
        title={`Privacy`}
        desc={`Your privacy is important to us. Let us explain why.`}
      />
      <PageContent>
        <h1>Privacy Policy</h1>
        <p>Private, definitely private. yes</p>
      </PageContent>
    </Layout>
  )
}
